import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { ContactUs } from 'src/app/shared/services/contact-us/contact-us';
import { ContactUsService } from 'src/app/shared/services/contact-us/contact-us.service';
import { ErrorComponent, Helpers, InformationComponent } from 'src/app/shared/util/helpers';
import { SUBSCRIPTION_PRICES, SubscriptionPriceEnum } from 'src/app/shared/util/subscription-prices.enum';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  public contactItem: ContactUs = new ContactUs();
  public href: string = "";
  public assistantHref: string = "";

  subscriptionPrices = SUBSCRIPTION_PRICES;
  isLoading: boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    public translate: TranslateService,
    private trackerService: TrackerService,
    public contactUsService: ContactUsService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Propero - Pricing');
    this.assistantHref = environment.assistantApp;
  }

  getSubscriptionPriceDetails(uniqueName: string) {
    const documentKey = Object.keys(this.subscriptionPrices).find(key =>
      key.toLowerCase().includes(uniqueName.toLowerCase())
    );

    return documentKey ? this.subscriptionPrices[documentKey as SubscriptionPriceEnum] : null;
  }

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    window.scrollTo(0, 0);
  }

  send(): void {
    // Validate form fields
    if (!this.contactItem.subject || !this.contactItem.email || !this.contactItem.content) {
      this.snackBar.openFromComponent(ErrorComponent, {
        data: { message: 'Vă rugăm să completați toate câmpurile.' },
        duration: 2000,
      });
      return;
    }

    // Set loading state to true
    this.isLoading = true;

    this.contactItem.date = new Date();

    this.contactUsService.addItem(this.contactItem)
      .pipe(
        finalize(() => {
          // Ensure loading state is set to false after request completes
          this.isLoading = false;
        })
      )
      .subscribe(
        results => {
          // Reset form fields
          this.contactItem.subject = '';
          this.contactItem.email = '';
          this.contactItem.content = '';

          // Show success message
          this.snackBar.openFromComponent(InformationComponent, {
            data: { message: 'Mesajul a fost trimis cu succes!' },
            duration: 2000,
          });
        },
        error => {
          // Show error message
          this.snackBar.openFromComponent(ErrorComponent, {
            data: { message: 'A apărut o eroare. Vă rugăm să încercați din nou.' },
            duration: 2000,
          });
        }
      );
  }
}